export default class MemoryCache {
  constructor(capacity) {
    this.cache = new Map();
    this.capacity = capacity;
  }

  /**
   * Get stored value from underlying storage
   * @param {string} key Cache storage key
   * @returns {object} Returns the current value associated with the key in underlying storage
   */
  getItem(key) {
    if (!this.cache.has(key)) return null;

    let val = this.cache.get(key);

    this.cache.delete(key);
    this.cache.set(key, val);

    return val;
  }

  /**
   * Store value in underlying storage
   * @param {string} key Cache storage key
   * @param {object} value Value to store
   */
  setItem(key, value) {
    this.cache.delete(key);

    if (this.cache.size === this.capacity) {
      this.cache.delete(this.cache.keys().next().value);
      this.cache.set(key, value);
    } else {
      this.cache.set(key, value);
    }
  }

  /**
   * Remove value from underlying storage
   * @param {string} key Cache storage key
   */
  removeItem(key) {
    this.cache.delete(key);
  }

  /**
   * Clear underlying storage
   */
  clear() {
    this.cache.clear();
  }
}
